import React from 'react';
import styles from './aside.scss';
import logo_white from './logo_white.png';
import logo_black from './logo_black.png';

const mapPanelToText = {
  'aboutUs': 'ABOUT US',
  'productsAndServices': 'PRODUCTS & SERVICES',
  'ourTeam': 'THE TEAM',
  'partner': 'OUR PARTNERS',
  'ourTrend': 'OUR PARTNERS',
  'contactUs': 'CONTACT US',
};

function Aside(props) {
  const {
    curPanel,
    asideStyle,
  } = props;

  const text = mapPanelToText[curPanel];

  return (
    <div className={styles.aside} style={{ backgroundColor: asideStyle.backgroundColor }}>
      <div className={styles.logo} onClick={() => window.open('http://2019.wow-trend.com')}>
        <img src={asideStyle.theme === 'white' ? logo_white : logo_black} />
      </div>

      <div className={styles.text} style={{ color: asideStyle.theme === 'white' ? '#fff' : '#111' }}>{text}</div>
    </div>
  );
}

export default Aside;